import i18next from 'i18next'
import React, { useContext, useEffect, useMemo, useState } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import LoadingCoverPixel from '../commonInterface/loadingCoverPixel'
import LoadingCoverSimple from '../commonInterface/loadingCoverSimple'
import TourTooltip from '../commonInterface/tourTooltip'
import { latestUpdateNumber } from './announceUpdatePage'
import { NavbarComp } from './Navbar'
import { Button, Portal } from '@blueprintjs/core'
import '../../css/copied-react-mosaic-component.css'
import 'normalize.css/normalize.css'
import '@blueprintjs/core/lib/css/blueprint.css'
import '@blueprintjs/icons/lib/css/blueprint-icons.css'
import '../../css/base.css'
// import Loadable from 'react-loadable'
import LoadableVisibility from 'react-loadable-visibility/react-loadable'
import ErrorBoundary from '../commonInterface/errorBoundary'
// -----------------------------------------------------------------------------------------------------------
import { GlobalContext, globalOnDemandVars } from '../../helper/context'
// -----------------------------------------------------------------------------------------------------------
// import awsconfig from '../../../aws/aws-exports'
// import { Auth, Hub } from 'aws-amplify'
// import { Authenticator, Greetings, Loading } from 'aws-amplify-react'
// import '../../backend/initAWS.js'
import { initConfig, initChatMemo } from '../../backend/configs/initData.js'
import LoadingCover from '../commonInterface/loadingCover'
import { initAddOns } from '../../backend/addons/initData'
import { initType1Lists, initTypeItemLists } from '../../backend/mediaItems/initData'
import { InsertFormArray } from '../addon/addons/parts/forEachInsertForm/insertFormRegister'
import { initLocalConfigs, resetConfig, updateConfigToCloud } from '../../backend/configs/updateData'
import { importCurrentTreeData, initTreeNode, setExampleTreeData } from '../../backend/treeNode/initData'
import { throttle, defer, delay } from 'lodash'
import 'firebase/auth'
import firebase from 'firebase/app'
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth'
import './firebaseAuthUI.css'
import * as firebaseui from 'firebaseui'
// import Iframe from 'react-iframe'
// import MemorizingEnterWindow from './memorizing/memorizingEnter.jsx'
import signInImage from '../../../assets/images/signIn.png'
import backgroundImage from '../../../assets/images/bg1.png'
import illustration1 from '../../../assets/images/illustration1.jpg'
import {
  initOnboarding,
  onboardingValues,
  updateOnboardingNumberTo, updateOnboardingWithLocal
} from '../../backend/onboarding/initAndUpdate'
// import * as OfflinePluginRuntime from 'offline-plugin/runtime'
import { initSpreadsheets } from '../../backend/spreadsheet/initData'
import { initMemorizingSetting } from '../../backend/memorizingSetting/initData'
import { initUploadType2s } from '../../backend/uploadType2/initData'
import './windowEvents'
import { useTranslation } from 'react-i18next'

// import AWSAppSyncClient from 'aws-appsync'
// import awsconfig from '../../aws-exports'
// import Amplify, { Auth } from 'aws-amplify'

const LoadingForWindow = ({ pastDelay, error, timedOut }) => {
  if (error) {
    return <div>error</div>
  } else if (timedOut) {
    return <div>timeOut</div>
  // } else if (pastDelay) {
  //   return <Spinner size={100} intent={'primary'} css={css`margin-top: 40vh;`} />
  } else {
    // return <LoadingCover showSpinner />
    return <LoadingCoverSimple />
  }
}
const LoadingForWindow2 = ({ pastDelay, error, timedOut }) => {
  if (error) {
    return <div>error</div>
  } else if (timedOut) {
    return <div>timeOut</div>
    // } else if (pastDelay) {
    //   return <Spinner size={100} intent={'primary'} css={css`margin-top: 40vh;`} />
  } else {
    // return <LoadingCover showSpinner />
    return <LoadingCover showSpinner spinnerSize={100} />
  }
}
const LoadingForWindow3 = ({ pastDelay, error, timedOut }) => {
  if (error) {
    return <div>error</div>
  } else if (timedOut) {
    return <div>timeOut</div>
    // } else if (pastDelay) {
    //   return <Spinner size={100} intent={'primary'} css={css`margin-top: 40vh;`} />
  } else {
    // return <LoadingCover showSpinner />
    return <LoadingCoverPixel />
  }
}

const LoadingDummy = () => (<div />)

const loadableConfigObject = {
  loading: LoadingForWindow
}
const loadableConfigObject2 = {
  loading: LoadingForWindow2
}
const loadableConfigObject3 = {
  loading: LoadingForWindow3
}

const OrganizingWindow = LoadableVisibility({
  loader: () => import('./organizing/organizing'),
  ...loadableConfigObject
})
const PixelWindow = LoadableVisibility(
  {
    loader: () => import('./pixel/wrapperForOrganizing'),
    ...loadableConfigObject3
  })
// const MemorizingEnterWindow = Loadable(
//   {
//     loader: () => import('./memorizing/memorizingEnter.jsx'),
//     ...loadableConfigObject,
//     loading: ParticleLoading
//   })
// const MemorizingEnterWindow = LoadableVisibility({
//   loader: () => import('./memorizing/memorizingEnter'),
//   ...loadableConfigObject
// })
// const MemorizingWindow = LoadableVisibility({
//   loader: () => import('./memorizing/memorizing'),
//   ...loadableConfigObject2
// })
const DashboardWindow = LoadableVisibility({
  loader: () => import('./dashboardWindow'),
  ...loadableConfigObject
})

const MobileMain = LoadableVisibility({
  loader: () => import('../mobile/mobileMain'),
  ...loadableConfigObject
})

const Welcome = LoadableVisibility({
  loader: () => import('./welcome'),
  loading: LoadingDummy
})
const AnnounceUpdatePage = LoadableVisibility({
  loader: () => import('./announceUpdatePage'),
  loading: LoadingDummy
})

// const Forum = () => {
//   useEffect(() => {
//     if (process.env.NODE_ENV === 'production') { window.analytics.page('forum') }
//   }, [])
//   return <Iframe url={'https://www.reddit.com/r/LearnObit/'} height={'100%'} width={'100%'} />
// }

const uAgent = window.navigator.userAgent.toLowerCase()
const mobilePhones = /iPhone|iPod|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i
const isMobile = mobilePhones.test(uAgent)

function InnerRouter () {
  //
  // useEffect(() => {
  //   console.tron.display({
  //     name: 'FullWindow / useEffect / appsync',
  //     value: {
  //       authState
  //     }
  //     // , important: true
  //   })
  //   if (authState === 'signedIn') {
  //     console.tron.log('appsync /  initConfig가 작동돼야함')
  //     initConfig()
  //   }
  // }, [authState])

  // const context = useContext(GlobalContext)

  return useMemo(() => (<div css={css`position: relative; width: 100%; flex: auto;`}>
    <ErrorBoundary where={'route'}>
      <OrganizingWindow />
    </ErrorBoundary>
  </div>), [])
}

function FullWindow ({ signedIn, isAnonymous }) {
  const { t } = useTranslation()
  const context = useContext(GlobalContext)

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      console.tron.display({
        name: 'FullWindow / useEffect / appsync',
        value: {
          authState: signedIn
        }
        // , important: true
      })
    }
    if (signedIn) {
      if (!isAnonymous) {
        // if (process.env.NODE_ENV !== 'production') {
        //   console.tron.log('appsync /  initConfig가 작동돼야함')
        // }
        Promise.all([
          initTreeNode(),
          initConfig(), initChatMemo(), initAddOns(), initTypeItemLists(InsertFormArray.map((item) => item.type)), initType1Lists(), initOnboarding(),
          initSpreadsheets(), initMemorizingSetting(), initUploadType2s().catch((e) => {
            if (process.env.NODE_ENV !== 'production') {
              console.tron.display({
                name: 'uploadType2 / initUploadType2s catch',
                value: {
                  e
                }
                // , important: true
              })
            }
          })
        ])
      } else {
        setExampleTreeData()
        initLocalConfigs()
        initOnboarding()

        globalOnDemandVars.set_treeNodesReady(true)
        globalOnDemandVars.set_configReady(true)
        globalOnDemandVars.set_chatMemoReady(true)
        globalOnDemandVars.set_addOnsReady(true)
        globalOnDemandVars.set_typeListsReady(true)
        globalOnDemandVars.set_type1Ready(true)
        globalOnDemandVars.set_spreadsheetReady(true)
        globalOnDemandVars.set_uploadType2Ready(true)
      }
    }
  }, [isAnonymous, signedIn])

  // -----------------------------------------------------------------------------------------------------------

  const hashRouter = useMemo(() => (
    <>
      <InnerRouter />
      <NavbarComp isAnonymous={isAnonymous} />
    </>), [isAnonymous])

  // -----------------------------------------------------------------------------------------------------------

  const [showWelcome, setShowWelcome] = useState(false)
  const [tourElement, setTourElement] = useState(null)

  useEffect(() => {
    if (context.onboardingReady) {
      if (process.env.NODE_ENV !== 'production') {
        console.tron.display({
          name: 'onboardingValues total',
          preview: context.onboardingReady,
          value: {
            onboardingValues,
            ready: context.onboardingReady
          }
          // , important: true
        })
      }
      if (onboardingValues.total !== 0) {
        setShowWelcome(false)
      }
      switch (onboardingValues.total) {
        case 0:
          delay(() => {
            if (onboardingValues.total === 0) {
              setShowWelcome(true)
              if (process.env.NODE_ENV === 'production') {
                window.analytics.track('Tutorial Started', {
                  stage: 0
                })
              }
            }
          }, 3000)
          break
        case 1:
          if (globalOnDemandVars.helpSectionOpen() && globalOnDemandVars.helpSectionId() === 'tour') {
            if (process.env.NODE_ENV === 'production') {
              window.analytics.track('Tutorial Started', {
                stage: 1
              })
            }
            setTourElement(<TourTooltip steps={[
              {
                content: 'Organize your learnings',
                target: '.organizeButton',
                placement: 'top'
              },
              {
                content: 'And then memorize them',
                target: '.memorizeButton',
                placement: 'top'
              },
              {
                content: 'Check this first',
                target: '.getStartedOrganize',
                placement: 'top'
              }
            ]} onComplete={() => {
              updateOnboardingNumberTo('total', 2)
              if (process.env.NODE_ENV === 'production') {
                window.analytics.track('Tutorial Completed', {
                  stage: 1
                })
              }
              setTourElement(null)
            }} />)
          }
          break
        case 2:
          if (globalOnDemandVars.helpSectionOpen()) {
            delay(() => {
              setTourElement(<TourTooltip steps={[
                {
                  content: 'Some links may be helpful',
                  target: '.links',
                  placement: 'top'
                }
              ]} disableScrolling onComplete={() => {
                updateOnboardingNumberTo('total', 3)
                setTourElement(null)
              }} />)
            }, 3000)
          }
          break
        case 3:
          if (globalOnDemandVars.hideSidebar() && globalOnDemandVars.insertConfig().sidebarVisible) {
            setTourElement(<TourTooltip steps={[
              {
                content: 'Check this',
                target: '.sidebarCover',
                placement: 'auto'
              }
            ]} onComplete={() => {
              updateOnboardingNumberTo('total', 4)
              setTourElement(null)
            }} />)
          } else {
            updateOnboardingNumberTo('total', 4)
          }
          break
        case 4:
          if (!window.todesktop) {
            setTourElement(<TourTooltip steps={[
              {
                content: (<div>
                  How about installing the desktop version?
                  <br /><br />
                  <a href={'https://dl.todesktop.com/200122yr0mt2j5i'} download><Button large icon={'cube-add'} text={'Install'} intent={'primary'} /></a>
                </div>),
                target: 'body',
                placement: 'center'
              }
            ]} onComplete={() => {
              updateOnboardingNumberTo('total', 5)
              setTourElement(null)
            }} />)
          } else {
            updateOnboardingNumberTo('total', 5)
          }
          break
        default:
          const lastUpdate = onboardingValues.lastUpdate
          if (process.env.NODE_ENV !== 'production') {
            console.tron.display({
              name: 'lastUpdate',
              preview: lastUpdate,
              value: {
                lastUpdate
              }
              // , important: true
            })
          }
          if (lastUpdate === 'new') {
            updateOnboardingWithLocal('lastUpdate', latestUpdateNumber)
          } else if (Number(lastUpdate) && (Number(lastUpdate) === latestUpdateNumber)) {
            if (!window.todesktop && (Math.random() > 0.6)) {
              setTourElement(<TourTooltip steps={[
                {
                  content: (<div>
                    {t('How about installing the desktop version?')}
                    <br /><br />
                    <a href={'https://dl.todesktop.com/200122yr0mt2j5i'} download>
                      <Button large icon={'cube-add'} text={t('Install')} intent={'primary'} /></a>
                  </div>),
                  target: 'body',
                  placement: 'center'
                }
              ]} onComplete={() => { setTourElement(null) }} />)
            }
          } else {
            globalOnDemandVars.openGlobalDialog()(
              'Updates', <AnnounceUpdatePage lastUpdate={Number(lastUpdate)} />
            )
            updateOnboardingWithLocal('lastUpdate', latestUpdateNumber)
          }
          break
      }
    }
  }, [context.onboardingReady, showWelcome, t])

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      if (context.onboardingReady) {
        const userData = globalOnDemandVars.userData()
        if (onboardingValues.total === 0) {
          window.analytics.identify(userData.uid, {
            anonymous: userData.isAnonymous,
            createdAt: (new Date()).toISOString(),
            visited: (onboardingValues.total + 1)
          })

          window.analytics.track('User First Visited', {
            date: (new Date()).toISOString(),
            desktopVersion: !!window.todesktop
          })
        } else {
          window.analytics.identify(userData.uid, {
            visited: (onboardingValues.total + 1),
            email: userData.isAnonymous ? undefined : (userData.email || userData.providerData[0].email || userData.providerData[0].displayName)
          })

          window.analytics.track('User Entered', {
            visited: (onboardingValues.total + 1),
            desktopVersion: !!window.todesktop
          })
        }

        if (window.todesktop) {
          window.analytics.identify(userData.uid, {
            desktopInstalled: true
          })
        }
      }
    }
  }, [context.onboardingReady])

  // -----------------------------------------------------------------------------------------------------------

  useEffect(() => {
    if (context.configReady && globalOnDemandVars.darkMode()) {
      document.body.classList.add('bp3-dark')
    }
  }, [context.configReady])

  // -----------------------------------------------------------------------------------------------------------

  return (useMemo(() => (signedIn ? (
    <>
      {showWelcome && <Portal><Welcome stopWelcoming={() => { setShowWelcome(false) }} /></Portal>}

      <div css={css`display: flex; flex-direction: column; position: fixed; width: 100%; height: 100%;`}>
        {context.configReady ? null : <LoadingCover showSpinner spinnerSize={100} text={t('Loading Configs')} action={
          <><Button minimal intent={'warning'} text={t('Reload')} onClick={() => {
            window.location.reload()
          }} />
            <br />
            <Button minimal intent={'warning'} text={t('Reset Configs')} onClick={() => {
              resetConfig().then(() => {
                return initConfig()
              })
            }} />
          </>
        } />}
        {hashRouter}
      </div>

      {tourElement}
    </>
  ) : null
  ), [signedIn, showWelcome, context.configReady, t, hashRouter, tourElement]))
}

// -----------------------------------------------------------------------------------------------------------

const uiConfig = {
  callbacks: {
    signInSuccessWithAuthResult: function (authResult, redirectUrl) {
      // User successfully signed in.
      // Return type determines whether we continue the redirect automatically
      // or whether we leave that to developer to handle.
      globalOnDemandVars.set_forceSignInPage(false)
      return false
    },
    uiShown: function () {
      if (window.todesktop) {
        let script
        // if (window.todesktop && (!signedIn || context.forceSignInPage)) {
        script = document.createElement('script')
        const desktopGoogleSignIn = () => {
          // console.log('google platform.js loaded')
          const googleSignInButtonElement = document.querySelector('.firebaseui-idp-google')
          const googleSignInButtonElement2 = document.querySelector('.firebaseui-list-item:nth-child(3)')
          if (!googleSignInButtonElement) {
            delay(desktopGoogleSignIn, 500)
            return null
          }
          // const googleSignInButtonElement = document.querySelector('.firebaseui-idp-google')
          googleSignInButtonElement.style.pointerEvents = 'none'
          googleSignInButtonElement2.style.cursor = 'pointer'
          googleSignInButtonElement2.addEventListener('click', (e) => {
            e.stopImmediatePropagation()
            window.gapi.load('auth2', () => {
              window.gapi.auth2.init({
                client_id: '529673593815-n1ojl5tloofto5stkuf246k7sme08dfj.apps.googleusercontent.com',
                ux_mode: 'redirect', // IMPORTANT!
                redirect_uri: 'https://app.learnobit.com/desktopSignIn.html'
              })
                .then(() => {
                  const auth = window.gapi.auth2.getAuthInstance()
                  auth.signIn()
                  if (script) { document.body.removeChild(script) }
                })
            })
          })
        }
        script.addEventListener('load', desktopGoogleSignIn)
        script.src = 'https://apis.google.com/js/platform.js'
        script.async = true
        script.defer = true
        document.body.appendChild(script)
      }
    }
  },
  // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
  signInFlow: window.todesktop ? 'redirect' : 'popup',
  // signInFlow: 'redirect',
  // signInSuccessUrl: window.todesktop ? 'https://learnobit-36a54.firebaseapp.com/desktopSignIn?mode=select&signInSuccessUrl=desktopSignIn' : undefined,
  // signInSuccessUrl: 'https://app.learnobit.com/desktopSignIn.html',
  'credentialHelper': firebaseui.auth.CredentialHelper.NONE,
  signInOptions: [
    firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID,
    {
      provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
      requireDisplayName: false
    },
    {
      provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      clientId: '529673593815-n1ojl5tloofto5stkuf246k7sme08dfj.apps.googleusercontent.com'
    }
    // firebase.auth.GithubAuthProvider.PROVIDER_ID
  ],
  autoUpgradeAnonymousUsers: true
}

// let brusherInit, brusher
function AppWithAuth () {
  useEffect(() => {
    globalOnDemandVars.set_isMobile(isMobile)
  }, [])
  // -----------------------------------------------------------------------------------------------------------
  // useEffect(() => {
  //   const script = document.createElement('script')
  //   script.src = 'https://widget.cloudinary.com/v2.0/global/all.js'
  //   script.async = true
  //   document.body.appendChild(script)
  // }, [])

  useEffect(() => {
    globalOnDemandVars.set_forceSignInPage(false)
  }, [])

  // -----------------------------------------------------------------------------------------------------------
  const context = useContext(GlobalContext)

  const [signedIn, setSignedIn] = useState(false)
  const [isAnonymous, setIsAnonymous] = useState(true)

  useEffect(() => {
    const unregister = firebase.auth().onAuthStateChanged(
      (user) => {
        if (process.env.NODE_ENV !== 'production') {
          console.tron.display({
            name: 'Authenticator',
            value: {
              user
            }
          // , important: true
          })
        }

        globalOnDemandVars.set_userData(user)
        defer(() => {
          setSignedIn(!!user)
          setIsAnonymous(!user || user.isAnonymous)
        })

        // if (!user) {
        //   if (!brusherInit) {
        //     if (!brusher) {
        //       brusher = new Brusher({
        //         image: '../../../assets/images/154c7350-28a8-11ea-bb45-f9f055ddbbba-Source-01-01.jpg',
        //         // keepCleared 를 false 로 하면 아예 안됨
        //         keepCleared: true,
        //         // TODO authBlur를 일단 해두긴 했는데 이건 퍼포먼스에 안좋고 실제 blur된 이미지를 백그라운드로 설정하라고함. 자세한건 https://github.com/kamranahmedse/brusher
        //         autoBlur: true
        //       })
        //     }
        //
        //     brusher.init()
        //     brusherInit = true
        //     console.tron.log('Authenticator brusher init')
        //   }
        // } else {
        //   if (brusherInit) {
        //     // const canvasWithBody = document.querySelectorAll('body > canvas')
        //     // canvasWithBody.forEach((oneCanvas) => {
        //     //   document.body.removeChild(oneCanvas)
        //     // })
        //     brusher.destroy()
        //     brusherInit = false
        //     console.tron.log('Authenticator brusher destroy')
        //   }
        // }
      }
    )
    return () => {
      unregister()
    }
  }, [context.forceSignInPage])

  // useEffect(() => {
  //   let script
  //   // if (window.todesktop && (!signedIn || context.forceSignInPage)) {
  //   if ((!signedIn || context.forceSignInPage)) {
  //     script = document.createElement('script')
  //     const desktopGoogleSignIn = () => {
  //       // console.log('google platform.js loaded')
  //
  //       const googleSignInButtonElement = document.querySelector('.firebaseui-idp-google')
  //       const googleSignInButtonElement2 = document.querySelector('.firebaseui-list-item:nth-child(3)')
  //
  //       if (!googleSignInButtonElement) {
  //         delay(desktopGoogleSignIn, 500)
  //         return null
  //       }
  //
  //       // const googleSignInButtonElement = document.querySelector('.firebaseui-idp-google')
  //       googleSignInButtonElement.style.pointerEvents = 'none'
  //       googleSignInButtonElement2.style.cursor = 'pointer'
  //
  //       googleSignInButtonElement2.addEventListener('click', (e) => {
  //         e.stopImmediatePropagation()
  //
  //         window.gapi.load('auth2', () => {
  //           window.gapi.auth2.init({
  //             client_id: '529673593815-n1ojl5tloofto5stkuf246k7sme08dfj.apps.googleusercontent.com',
  //             ux_mode: 'redirect', // IMPORTANT!
  //             redirect_uri: 'https://app.learnobit.com/desktopSignIn.html'
  //           })
  //             .then(() => {
  //               const auth = window.gapi.auth2.getAuthInstance()
  //               auth.signIn()
  //             })
  //         })
  //       })
  //     }
  //     script.addEventListener('load', desktopGoogleSignIn)
  //     script.src = 'https://apis.google.com/js/platform.js'
  //     script.async = true
  //     script.defer = true
  //     document.body.appendChild(script)
  //   }
  //   return () => {
  //     if (script) { document.body.removeChild(script) }
  //   }
  // }, [context.forceSignInPage, signedIn])

  const [tourElement, setTourElement] = useState(null)
  useEffect(() => {
    delay(() => {
      setTourElement(<TourTooltip steps={[
        { content: i18next.t('Try LearnObit without signing up'), target: '.firebaseui-idp-anonymous', placement: 'left' },
        { content: i18next.t('Sign up here'), target: '.firebaseui-idp-password', placement: 'left' }
      ]} disableOverlay />)
    }, (signedIn ? 1000 : 4000))
    return () => {
      setTourElement(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.forceSignInPage])
  useEffect(() => {
    if (signedIn) {
      setTourElement(null)
    }
  }, [signedIn])

  const signInPage = useMemo(() => (
    <div css={css`
//background-image: url(${backgroundImage}); background-size: cover; background-repeat: no-repeat; background-color: var(--primary2);
width: 100%; height: 100%; position: fixed; z-index: 2; appearance: none;`} onContextMenu={(e) => e.preventDefault()}>
      <div
        css={css`background-image: url(${illustration1}); background-size: auto 50%; background-repeat: no-repeat; width: 100%; height: 100%;`}>
        <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()} /></div>
    </div>
  ), [])

  const signInPageWithTooltip = useMemo(() => (
    <>
      {tourElement}
      {signInPage}
    </>
  ), [signInPage, tourElement])

  return useMemo(() => (isMobile ? (<MobileMain />) : (signedIn && !context.forceSignInPage ? <FullWindow signedIn={signedIn} isAnonymous={isAnonymous} /> : signInPageWithTooltip)
  ), [context.forceSignInPage, isAnonymous, signInPageWithTooltip, signedIn])

  // useEffect(() => {
  //   setExampleTreeData()
  //   initLocalConfigs()
  //   // initOnboarding()
  //
  //   globalOnDemandVars.set_userData({
  //     uid: 'sdfsdfffwe',
  //     isAnonymous: true
  //   })
  //   globalOnDemandVars.set_onboardingReady(true)
  //   globalOnDemandVars.set_treeNodesReady(true)
  //   globalOnDemandVars.set_configReady(true)
  //   globalOnDemandVars.set_chatMemoReady(true)
  //   globalOnDemandVars.set_addOnsReady(true)
  //   globalOnDemandVars.set_typeListsReady(true)
  //   globalOnDemandVars.set_type1Ready(true)
  //   globalOnDemandVars.set_spreadsheetReady(true)
  //   globalOnDemandVars.set_uploadType2Ready(true)
  // }, [])
  //
  // return <OrganizingWindow />
}

// export default withAuthenticator(FullWindow, true, [], federated, {})
// export default FullWindow
export default AppWithAuth
